// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__3lmJJ","signatureButtonsRight":"ModalSign_signatureButtonsRight__24CYd"};